const images = {
    loghi: {
        // logoMobile: require('./dedalus/logo_mobile.png'),
        // logo: require('./dedalus/logoBig.png'),
        alisa: require('./loghi/alisa.png'),
        logoLD: require('./loghi/logo_LD.png'),
        logoAgid: require('./loghi/logo_agid.png'),
        logoSpid: require('./loghi/logo_spid.png'),
        logoAsl3: require('./loghi/LogoAsl3New.png'),
        logoAsl5: require('./loghi/LogoAsl5New.png'),
        logoAsl3Bianco: require('./loghi/asl3_bianco.png'),
        logoAsl5Bianco: require('./loghi/asl5_bianco.png'),


        logoLDBianco: require('./loghi/ld-bianco.png'),
    },
    // immagini: {
    // //     palazzoRegione: require('./dedalus/palazzo_regione.jpg'),
    //palazzoRegioneNews: require('./icone/RegioneLiguria_News.jpg')
    //},
    illustrazioni: {
        schedaOspedale: require('./illustrazioni/SchedaOspedale.png')
    }
}

export default images;